"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveRateToGolfLine = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const _ = require("lodash");
const orders_1 = require("../orders");
const adjustRateTimeForRange_1 = require("./adjustRateTimeForRange");
const saveRateToGolfLine = (country_id, region_id, line, rate, course_policy, require_caddies = false, require_carts = false, margin_discount_percentage = 0, tee_time_range, historical_rate = null) => {
    const golf_line = _.cloneDeep(line);
    let group_sizes = [];
    if (rate.max_pax) {
        group_sizes = (0, orders_1.getGroupSizes)(golf_line.where_when_who.number_of_golfers, rate.max_pax, golf_line.tee_time);
    }
    let rate_earliest_time = rate.earliest_time.slice(0, 5);
    let rate_latest_time = rate.latest_time.slice(0, 5);
    if (!golf_line?.tee_time?.start_time && !golf_line?.tee_time?.end_time) {
        golf_line.tee_time = {
            groups: group_sizes,
            start_time: rate_earliest_time,
            end_time: rate_latest_time,
            custom: false,
            note: "",
        };
    }
    else {
        if (golf_line.tee_time.start_time === rate.earliest_time.slice(0, 5) &&
            golf_line.tee_time.end_time === rate.latest_time.slice(0, 5)) {
            golf_line.tee_time = {
                start_time: rate_earliest_time,
                end_time: rate_latest_time,
                groups: group_sizes,
                custom: false,
                note: "",
            };
        }
        else {
            golf_line.tee_time = {
                ...golf_line?.tee_time,
                groups: group_sizes,
            };
        }
    }
    if (tee_time_range) {
        const new_range = (0, adjustRateTimeForRange_1.adjustRateTimeForRange)(tee_time_range, rate);
        rate_earliest_time = new_range.earliest_time;
        rate_latest_time = new_range.latest_time;
        golf_line.tee_time = {
            ...golf_line.tee_time,
            start_time: rate_earliest_time,
            end_time: rate_latest_time,
            custom: true,
        };
    }
    const caddie_obj = {
        vat: rate?.supplier_offerings?.golf?.offerings?.caddies?.vat || 0,
        withholding_tax: rate?.supplier_offerings?.golf?.offerings?.caddies?.withholding_tax || 0,
    };
    if (course_policy?.caddies?.enabled === "YES") {
        // Need to define the caddies
        if (course_policy?.caddies?.type === "SINGLE_CADDIES") {
            golf_line.caddies = {
                ...caddie_obj,
                enabled: rate?.product_config?.caddie || rate?.product_config?.shared_caddie
                    ? false
                    : (0, orders_1.getCaddiePolicy)(rate) === "compulsory" || require_caddies,
                type: "SINGLE_CADDIE",
                quantity: golf_line.where_when_who?.number_of_golfers,
                cost_per_caddie: Number(rate?.caddie_price),
                total: rate?.caddie_price * golf_line.where_when_who?.number_of_golfers,
                payment_option: rate?.product_config?.caddie || rate?.product_config?.shared_caddie
                    ? "INCLUDED"
                    : !course_policy?.caddies?.prepayment_available
                        ? "ON_ARRIVAL"
                        : "IN_ADVANCE",
            };
        }
        if (course_policy?.caddies?.type === "SHARED_CADDIES") {
            golf_line.caddies = {
                ...caddie_obj,
                enabled: rate?.product_config?.caddie || rate?.product_config?.shared_caddie
                    ? false
                    : (0, orders_1.getCaddiePolicy)(rate) === "compulsory" || require_caddies,
                type: "SHARED_CADDIE",
                quantity: 0,
                cost_per_caddie: Number(rate?.caddie_price),
                total: 0,
                payment_option: rate?.product_config?.caddie || rate?.product_config?.shared_caddie
                    ? "INCLUDED"
                    : !course_policy?.caddies?.prepayment_available
                        ? "ON_ARRIVAL"
                        : "IN_ADVANCE",
            };
        }
    }
    else {
        golf_line.caddies = {
            ...caddie_obj,
            enabled: false,
            quantity: 0,
            total: 0,
            vat: 0,
            type: undefined,
            cost_per_caddie: 0,
            withholding_tax: 0,
        };
    }
    if (course_policy?.carts?.enabled === "YES") {
        let cart_obj = {
            vat: rate?.supplier_offerings?.golf?.offerings?.carts?.vat || 0,
            withholding_tax: rate?.supplier_offerings?.golf?.offerings?.carts?.withholding_tax || 0,
            enabled: rate?.product_config?.shared_cart || rate?.product_config?.single_cart
                ? false
                : (0, orders_1.getCartPolicy)(rate) === "compulsory" || require_carts,
            payment_option: rate?.product_config?.shared_cart || rate?.product_config?.single_cart
                ? "INCLUDED"
                : !course_policy?.carts?.prepayment_available
                    ? "ON_ARRIVAL"
                    : "IN_ADVANCE",
        };
        // If both cart types are available then we need to set values to 0 to let them decide
        if (rate?.shared_cart_enabled && rate?.single_cart_enabled) {
            const quantity = golf_line.where_when_who?.number_of_golfers;
            cart_obj = {
                ...cart_obj,
                types: [
                    {
                        cost_per_cart: Number(rate?.single_cart_price),
                        total: Number(rate?.single_cart_price) * quantity,
                        quantity: quantity,
                        type: "SINGLE_CART",
                    },
                    {
                        cost_per_cart: Number(rate?.shared_cart_price),
                        total: 0,
                        quantity: 0,
                        type: "SHARED_CART",
                    },
                ],
            };
        }
        // If its Shared Only Carts in the policy
        if (rate?.shared_cart_enabled && !rate?.single_cart_enabled) {
            // the quantity is the number of players divided by 2 rounded up to the nearest whole number
            const quantity = Math.ceil(golf_line.where_when_who?.number_of_golfers / 2);
            cart_obj = {
                ...cart_obj,
                types: [
                    {
                        cost_per_cart: Number(rate?.shared_cart_price),
                        total: Number(rate?.shared_cart_price) * quantity,
                        quantity: quantity,
                        type: "SHARED_CART",
                    },
                ],
            };
        }
        // If its Single Only Carts in the policy
        if (!rate?.shared_cart_enabled && rate?.single_cart_enabled) {
            // the quantity is the number of players divided by 2 rounded up to the nearest whole number
            const quantity = golf_line.where_when_who?.number_of_golfers;
            cart_obj = {
                ...cart_obj,
                types: [
                    {
                        cost_per_cart: Number(rate?.single_cart_price),
                        total: Number(rate?.single_cart_price) * quantity,
                        quantity: quantity,
                        type: "SINGLE_CART",
                    },
                ],
            };
        }
        golf_line.carts = cart_obj;
    }
    else {
        golf_line.carts = {
            vat: 0,
            withholding_tax: 0,
            enabled: false,
            payment_option: null,
            types: [],
        };
    }
    golf_line.product = {
        id: rate.product_id,
        name: rate.product_name,
        type: rate.product_type_name.en,
        config: rate.product_config,
        custom: historical_rate ? true : false,
    };
    if (rate?.hole_options && rate?.hole_options?.length > 0) {
        golf_line.hole_options = {
            ...golf_line.hole_options,
            selected_option: rate.course_hole_combination,
        };
    }
    golf_line.supplier = {
        id: rate.supplier_id,
        name: rate.supplier_name,
        currency: rate.base_currency,
        offerings: rate.supplier_offerings,
    };
    let green_fee_margin = rate.rate_id === golf_line.green_fee.rate_id
        ? golf_line.green_fee.margin
        : rate.margin;
    let green_fee_cost = rate.cost_price;
    if (historical_rate) {
        // DO THE MARGIN DISCOUNT PERCENTAGE
        if (margin_discount_percentage) {
            const percentage = (100 - margin_discount_percentage) / 100;
            green_fee_margin = green_fee_margin * percentage;
        }
        green_fee_margin = Number((green_fee_margin * (1 + historical_rate.percentage / 100)).toFixed(0));
        green_fee_cost = Number((green_fee_cost * (1 + historical_rate.percentage / 100)).toFixed(0));
    }
    const green_fee_price = green_fee_cost + green_fee_margin;
    golf_line.adjustments = {
        ...golf_line.adjustments,
        margin_discount_percentage: margin_discount_percentage || 0,
    };
    golf_line.green_fee = {
        rate_id: rate.rate_id,
        vat: rate.supplier_offerings?.golf?.offerings?.green_fees?.vat || 0,
        withholding_tax: rate.supplier_offerings?.golf?.offerings?.green_fees?.withholding_tax ||
            0,
        custom_rate: historical_rate ? true : false,
        course_hole_combination: rate?.hole_options && rate?.hole_options?.length > 0
            ? {
                id: rate.course_hole_combination,
                holes: rate?.hole_options?.find((hole_option) => hole_option.id === rate.course_hole_combination)?.description,
            }
            : null,
        caddie_price: Number(rate.caddie_price),
        product_config: rate.product_config,
        single_cart_enabled: rate.single_cart_enabled,
        single_cart_price: Number(rate.single_cart_price),
        shared_cart_price: Number(rate.shared_cart_price),
        shared_cart_enabled: rate.shared_cart_enabled,
        odd_number_surcharge: Number(rate.odd_number_surcharge),
        max_pax: rate.max_pax,
        currency: rate.base_currency,
        margin: green_fee_margin,
        cost: green_fee_cost,
        price: green_fee_price,
        surcharge: Number(rate.odd_number_surcharge),
        availability_days: rate.availability_days,
        earliest_time: rate.earliest_time,
        latest_time: rate.latest_time,
        start_date: rate.start_date,
        end_date: rate.end_date,
        caddie_policy: rate.caddie_policy,
        cart_policy: rate.cart_policy,
        booking_window_start_date: rate.booking_window_start_date,
        booking_window_end_date: rate.booking_window_end_date,
        rate_note: rate.note,
        historic_rate: historical_rate
            ? {
                ...{
                    ...historical_rate.rate,
                    margin: historical_rate.rate.margin,
                },
                percentage: historical_rate.percentage,
                date: historical_rate.date,
            }
            : null,
        estimated: historical_rate ? true : false,
        multiples: rate.multiples,
    };
    golf_line.where_when_who.region_id = region_id;
    golf_line.where_when_who.country_id = country_id;
    return golf_line;
};
exports.saveRateToGolfLine = saveRateToGolfLine;
